import styled from 'styled-components';

export const AppContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const SidebarWrapper = styled.div`
  position: sticky;
  left: 0;
  top: 0;
  height: 100vh;
  z-index: 1000;
  flex-shrink: 0;

  @media (max-width: 768px) {
    position: fixed;
    height: auto;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const ContentArea = styled.div`
  flex: 1;
  padding: 20px;
  min-height: calc(100vh - 60px);
  background-color: #F0F2F5;
  cursor: default;
  box-sizing: border-box;
  margin-top: 60px;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`; 